export default __webpack_public_path__ + "static/media/forest_background.c31f7016.jpg";